export const MobileTransactionalCreateSaleModalTabs = {
  WHO: "Who",
  WHAT: "What",
  WHEN: "When",
  PRICE: "Price",
  REVIEW: "Review",
} as const;

export type MobileTransactionalCreateSaleModalTabId =
  (typeof MobileTransactionalCreateSaleModalTabs)[keyof typeof MobileTransactionalCreateSaleModalTabs];

export const MobileTransactionalCreateSaleModalTabOrder: MobileTransactionalCreateSaleModalTabId[] =
  [
    MobileTransactionalCreateSaleModalTabs.WHO,
    MobileTransactionalCreateSaleModalTabs.WHAT,
    MobileTransactionalCreateSaleModalTabs.WHEN,
    MobileTransactionalCreateSaleModalTabs.PRICE,
    MobileTransactionalCreateSaleModalTabs.REVIEW,
  ];
